import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})

export class ToasterService {
  private messageService = inject(MessageService);

  success(summary: string, detail: string = '', life: number = 3000) {
    this.messageService.add({ severity: 'success', summary, detail, life });
  }

  info(summary: string, detail: string = '', life: number = 3000) {
    this.messageService.add({ severity: 'info', summary, detail, life });
  }

  warn(summary: string, detail: string = '', life: number = 3000) {
    this.messageService.add({ severity: 'warn', summary, detail, life });
  }

  error(summary: string, detail: string = '', life: number = 3000) {
    this.messageService.add({ severity: 'error', summary, detail, life });
  }

  /**
   * Show a success toast with a clickable link
   * @param summary Toast title
   * @param detail Toast message
   * @param link URL to navigate to when link is clicked
   * @param linkText Text to display for the link (default: 'View Progress')
   * @param life How long the toast stays visible in ms (default: 5000)
   */
  successWithLink(summary: string, detail: string, link: string, linkText: string = 'View Progress', life: number = 5000) {
    this.messageService.add({
      severity: 'success',
      summary,
      detail,
      life,
      data: { link, linkText }
    });
  }

  clear() {
    this.messageService.clear();
  }
  
  MESSAGE_TYPES = {
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warn'
  };
  
  
  private severityMap = {
    [this.MESSAGE_TYPES.SUCCESS]: 'Success',
    [this.MESSAGE_TYPES.ERROR]: 'Error',
    [this.MESSAGE_TYPES.WARNING]: 'Warning'
  };
  
  
  showMessage(type: any, detail: any, summary?: any) {

    let message = this.extractErrorMessage(detail) || 'Something went wrong. Please try again.';

   

    this.messageService.add({
      severity: type,
      summary: summary || this.severityMap[type],
      detail: message
    });
  }

  private extractErrorMessage(detail: any): string {
    if (!detail) return 'Something went wrong. Please try again.';
    if (typeof detail === 'string') return detail;

    if (typeof detail.error == 'object') {
      if (typeof detail.error.error === 'string') return detail.error.error;
      if (typeof detail.error.message === 'string') return detail.error.message;
      if (typeof detail.error.data === 'string') return detail.error.data;
   
    }else if (typeof detail.message === 'string') {
       // This case is placed last as it specifically handles errors thrown from the frontend.  
      // It prevents displaying any message from the HTTP response to avoid unintended messages.  
      return detail.message;
    }

    return 'Something went wrong. Please try again.';
  }
}
